<template lang="html">

  <section class="wrapper legal">
    <div class="container">
      <h1>Política de cookies</h1>
      <p>La página web de www.launionhacelafuerza.es es utiliza “cookies” con la finalidad de poder recabar información acerca del
        uso que se hace de ella.</p>
      <p>Utilizamos cookies para facilitar tu navegación en la página, distinguirte de otros usuarios, solucionar
        problemas y mejorar tu experiencia de uso. También podemos utilizar cookies para recabar información sobre tus
        referencias y personalizar nuestra web en base a ellas, previo tu consentimiento.</p>
      <h2>COOKIES</h2>
      <p>Las cookies son archivos que se descargan en tu dispositivo para almacenar información sobre las preferencias y
        usos que haces en nuestra página.</p>
      <p>La información que se guarda en estos archivos puede actualizarse y ser recuperada, e incluye datos como el
        momento en que visitas nuestra web, cuántas páginas visitas y en qué orden… así como el tiempo que empleas en él
        y los sitios que visitas antes y después.</p>
      <h2>TIPO DE COOKIES QUE SE USAN EN NUESTRA WEB</h2>
      <p>La página web de launionhacelafuerza utiliza cookies de terceros.</p>
      <h2>COOKIES DE TERCEROS</h2>
      <p>Utilizamos el sistema de medición de Google, Analytics, para medir las interacciones de los usuarios con los
        contenidos en nuestra página, saber el número total de usuarios que tenemos y las partes más populares de la
        web.</p>
      <h3>__UTMA</h3>
      <p>Duración - Dos años a partir de la configuración o actualización</p>
      <p>Descripción - Se usa para distinguir usuarios y sesiones. La cookie se crea cuando se ejecuta la biblioteca
        JavaScript y no hay ninguna cookie __utma. La cookie se actualiza cada vez que se envían datos a Google
        Analytics.</p>
      <h3>__UTMT</h3>
      <p>Duración - 10 minutos</p>
      <p>Descripción - Se usa para limitar el porcentaje de solicitudes.</p>
      <h3>__UTMB</h3>
      <p>Duración - 30 minutos a partir de la configuración o actualización</p>
      <p>Descripción - Se usa para determinar nuevas sesiones o visitas. La cookie se crea cuando se ejecuta la
        biblioteca JavaScript y no hay ninguna cookie __utmb. La cookie se actualiza cada vez que se envían datos a
        Google Analytics.</p>
      <h3>__UTMC</h3>
      <p>Duración - Fin de la sesión del navegador</p>
      <p>Descripción - No se usa en ga.js. Se configura para interactuar con urchin.js. Anteriormente, esta cookie
        actuaba junto con la cookie __utmb para determinar si el usuario estaba en una nueva sesión o visita.</p>
      <h3>__UTMZ</h3>
      <p>Duración - Seis meses a partir de la configuración o actualización</p>
      <p>Descripción - Almacena la fuente de tráfico o la campaña que explica cómo ha llegado el usuario al sitio. La
        cookie se crea cuando se ejecuta la biblioteca JavaScript y se actualiza cada vez que se envían datos a Google
        Analytics.</p>
      <h3>__UTMV</h3>
      <p>Duración - Dos años a partir de la configuración o actualización</p>
      <p>Descripción - Se usa para almacenar datos de variables personalizadas de visitante. Esta cookie se crea cuando
        un programador usa el método _setCustomVar con una variable personalizada de visitante. También se usaba para el
        método _setVar retirado. La cookie se actualiza cada vez que se envían datos a Google Analytics.</p>
      <p>Si navegas por nuestra página web, estás consintiendo el uso de las cookies.</p>
      <h2>DESHABILITAR Y BLOQUEAR COOKIES, Y RETIRAR TU CONSENTIMIENTO</h2>
      <p>Puedes evitar que se almacenen estas cookies en tu dispositivo y seguir navegando en nuestra página (aunque
        algunos de los contenidos o servicios podrían ser limitados) navegando de incógnito o deshabilitando las cookies
        en tu navegador.</p>
      <p>Si estabas de acuerdo con la instalación de cookies pero has cambiado de idea, puedes retirar tu consentimiento
        simplemente eliminando las cookies que se hubieran almacenado en tu dispositivo.</p>
      <p>Para obtener información sobre cómo navegar de incógnito, deshabilitar y/o eliminar las cookies, tienes que
        leer la documentación de uso del navegador que utilizas sobre configuración y ajustes de cookies.</p>
      <p>Te dejamos enlaces a esta documentación de los navegadores más populares:</p>
      <ul>
        <li>Internet Explorer 9</li>
        <li>Internet Explorer 11</li>
        <li>Microsft Edge</li>
        <li>Firefox</li>
        <li>Chrome</li>
        <li>Safari</li>
      </ul>
      <h2>CAMBIOS EN LA POLÍTICA DE COOKIES</h2>
      <p>Podríamos actualizar esta Política de Cookies en cualquier momento, por lo que te recomendamos que compruebes
        los términos cada vez que navegues en la página web de Mundo Agro.</p>
    </div>
  </section>

</template>

<script lang="js">
  export default {
    name: 'politica-de-cookies',
  }
</script>

<style scoped lang="scss">
  .politica-de-cookies {}
</style>


// WEBPACK FOOTER //
// src/components/views/politica-de-cookies.vue